<button
    mat-raised-button
    class="primary-btn rounded button2"
    (click)="solicitarAprobacion()"
    *ngIf="
        caso.estado !== 'Bloqueado'
        && caso.estado !== 'Finalizado'
        && caso.solucion === 'No Determinado'
        && permisos.includes('Analista de Gestión de Fraudes')
        && cantidad_tareas_en_ejecucion === 0
        && cantidad_tareas_en_pendiente === 0
        && (caso.tipo_caso === 'Detección y Análisis de Fraudes' || (caso.tipo_caso === 'Gestión Administrativa de Fraudes' && caso.requiereDobleAprobacion === true))
    "
>
    <span class="mat-button-wrapper">
        Solicitar Revisión al Supervisor
    </span>
</button>
